import moment from 'moment';
import WorkoutResultBase from './WorkoutResultBase';

/**
 * The best name I could ever come with ¯\_(ツ)_/¯
 */
class WorkoutResultForAdmin extends WorkoutResultBase {
  constructor({
    _id = null,
    user = null,
    wod = null,
    workout = null,
    workoutType = null,
    workoutTypeModel = null,
    date = null,
    result = null,
    resultType = '',

    isPublic = null,
    createdAt = null,
    updatedAt = null,
  }) {
    super();

    // deconstruct nested props
    const {
      _id: userId = null,
      firstName: userFirstName = '',
      lastName: userLastName = '',
    } = user ? user : {};
    const { _id: wodId = null, name: wodName = '' } = wod ? wod : {};
    const { _id: workoutId, title: workoutTitle } = workout ? workout : {};

    this.id = _id;
    this.user = {
      id: userId,
      firstName: userFirstName,
      lastName: userLastName,
    };
    this.wod = {
      id: wodId,
      name: wodName,
    };
    this.workout = {
      id: workoutId,
      title: workoutTitle,
    };
    this.workoutType = workoutType;
    this.workoutTypeModel = workoutTypeModel;
    this.date = date ? moment(date) : null;
    this.result = result;
    this.resultType = resultType;
    this.isPublic = isPublic;
    this.createdAt = createdAt ? moment(createdAt) : null;
    this.updatedAt = updatedAt ? moment(updatedAt) : null;
  }
}

export default WorkoutResultForAdmin;
